"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LootContractMintButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const wagmi_1 = require("wagmi");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const exchange_1 = require("@framework/exchange");
const mintBox_json_1 = __importDefault(require("@framework/abis/json/ERC721LootBoxSimple/mintBox.json"));
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const utils_1 = require("../../../../../utils");
const dialog_1 = require("./dialog");
const LOOT_BOX_MINT_DIALOG_KEY = "lootBoxMint";
const LootContractMintButton = (props) => {
    const { className, contract, contract: { address, id: contractId }, disabled, variant, } = props;
    const { address: account = "" } = (0, wagmi_1.useAccount)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openFormDialog, formDialogUniqueKey, mode } = (0, react_hooks_1.useDialogForm)();
    const handleMintToken = () => {
        openFormDialog(`${LOOT_BOX_MINT_DIALOG_KEY}.${contractId}`, void 0, "button");
    };
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)(async (values) => {
        const content = (0, exchange_1.convertDatabaseAssetToChainAsset)(values.lootBox.content.components);
        return writeContractAsync({
            address: address,
            abi: mintBox_json_1.default,
            functionName: "mintBox",
            args: [values.account, values.lootBox.templateId, content],
        });
    });
    const handleMintTokenConfirmed = async ({ data }) => {
        await metaFn(data);
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleMintToken, icon: icons_material_1.AddCircleOutline, message: "form.buttons.mintToken", className: className, dataTestId: "LootContractMintButton", disabled: disabled || (0, utils_1.shouldDisableByContractType)(contract), variant: variant }), (0, jsx_runtime_1.jsx)(dialog_1.MintLootBoxDialog, { onExternalConfirm: handleMintTokenConfirmed, open: formDialogUniqueKey === `${LOOT_BOX_MINT_DIALOG_KEY}.${contractId}.${mode}`, initialValues: {
                    contractId,
                    lootId: 0,
                    account,
                } })] }));
};
exports.LootContractMintButton = LootContractMintButton;
//# sourceMappingURL=index.js.map